;(function ( $ ) {

  var popupConfigArray = [],
      hrefList = [];

  $.fn.ruckusLightbox = function()
  {
    if (!this.length) { return; }

    this.each(function() {
      var $this = $(this);

      config = popupConfigFor($this);
      $this.magnificPopup(config);
    });
  };

  function addClass(elt)
  {
    var popupType = elt.data('popup-type'),
        popupSrc = elt.attr('href');

    switch(popupType)
    {
      case 'billboard':
        elt.addClass('mfp-inline');
        break;
      case 'video':
        elt.addClass('mfp-ajax');
        break;
    }
  }

  function popupConfigFor(elt)
  {
    var popupType = elt.data('popup-type'),
        popupSrc = elt.attr('href');


    switch(popupType)
    {
      // case 'billboard':
      //   config = {
      //     //alignTop: true,
      //     overflowY: 'scroll', // as we know that popup content is tall we set scroll overflow by default to avoid jump
      //     type: 'inline',
      //     preloader: false,
      //     items: {
      //       src: popupSrc,
      //       type: 'inline'
      //     },
      //     callbacks: {
      //       beforeClose: _disposeOfVideo
      //     }
      //   };
      //   break;
      case 'customer':
      case 'partner':
        config = {
          fixedContentPos: false,
          fixedBgPos: true,
          overflowY: 'auto',
          preloader: false,
          midClick: true,
          removalDelay: 300,
          mainClass: 'my-mfp-zoom-in',
          items: {
            src: popupSrc,
            type: 'inline'
          },
          callbacks: {
            beforeClose: _disposeOfVideo
          }
        };
        break;
      case 'image':
        config = {
          type: 'image',
          closeOnContentClick: true,
          mainClass: 'mfp-img-mobile'
        };
        break;
      // case 'image-gallery':
      //   config = {
      //     type: 'image',
      //     closeOnContentClick: true,
      //     mainClass: 'mfp-img-gallery',
      //     delegate: 'a',
      //     tLoading: 'Loading image #%curr%...',
      //     gallery: {
      //       enabled: true,
      //       navigateByImgClick: true,
      //       preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      //     },
      //     image: {
      //       tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      //       titleSrc: function(item) {
      //         return item.el.attr('title');
      //       }
      //     }
      //   };
      //   break;
      // case 'product360':
      case 'iframe':
        config = {
          disableOn: 640,
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        };
        break;

      case 'ruckus-ready-partner':
        config = {
          fixedContentPos: false,
          fixedBgPos: true,
          overflowY: 'auto',
          preloader: true,
          items: {
            src: popupSrc,
            type: 'ajax'
          },
          mainClass: 'mfp-ruckus-ready',
          src: popupSrc,
          removalDelay: 300,
          callbacks: {
            beforeClose: _disposeOfVideo
          }
        };
        break;

      case 'table':
        config = {
          type: 'inline',
          fixedContentPos: false,
          fixedBgPos: true,
          overflowY: 'auto',
          //closeBtnInside: true,
          preloader: false,
          midClick: true,
          removalDelay: 300,
          mainClass: 'mfp-table'
        };
        break;
      // case 'mediagrid':
      //   config = {
      //     type: 'inline',
      //     fixedContentPos: false,
      //     fixedBgPos: true,
      //     overflowY: 'auto',
      //     preloader: false,
      //     midClick: true,
      //     removalDelay: 300,
      //     mainClass: 'mfp-mediagrid',
      //     items: {
      //       src: popupSrc,
      //       type: 'inline'
      //     },
      //     callbacks: {
      //       beforeClose: _disposeOfVideo
      //     }
      //   };
      //   break;
      // case 'video':
      //   config = {
      //     //alignTop: false,
      //     fixedBgPos: true,
      //     preloader: true,
      //     disableOn: 480,
      //     items: {
      //       src: popupSrc,
      //       type: 'ajax'
      //     },
      //     callbacks: {
      //       beforeClose: _disposeOfVideo
      //     }
      //   };
      //   break;
      // default:
      //   break;
    }
    //popupConfigArray.push(config);
    return config;
  }

  function _disposeOfVideo() {
    // the video js object is set up in the drupal template that outputs the video player
    // we need to compare against undefined because of homepage billboard content swapping
    // problem
    // if (typeof video !== "undefined") {
    //   video.dispose();
    // }

    if ( $('section.video').length == 1 ) {
      video = videojs('video_player');
      video.dispose();
    }
  }

}( jQuery ));
